/**
 * Human-readable labels for bulk action types.
 * Single source of truth — update here when new action types are added
 * to the backend bulk_action.go.
 */
const LABELS: Record<string, string> = {
  status_change: 'Update status',
  tag: 'Add tag',
  remove_tag: 'Remove tag',
  comment: 'Add comment',
  delete: 'Delete',
  scan: 'Scan',
};

/**
 * Converts a raw action string (e.g. "status_change") into a human-readable
 * label (e.g. "Update status"). Falls back to replacing underscores with spaces
 * for any action not in the lookup table.
 */
export function humanizeAction(action: string): string {
  return LABELS[action] ?? action.replace(/_/g, ' ');
}
